// src/TeamRow.js
import React from "react";

const tdStyle = {
  border: "1px solid #e5e7eb",
  padding: "10px 14px",
  verticalAlign: "middle",
};

const buttonStyle = {
  padding: "6px 12px",
  borderRadius: "4px",
  border: "none",
  fontWeight: "600",
  cursor: "pointer",
  fontSize: "0.85rem",
};

function TeamRow({
  team,
  quantity,
  onChange,
  onBuy,
  onSell,
  onSelect,
  sharesOwned = 0,
  marketOpen = true,
}) {
  const teamId = team.id || team.name;

  // Safe logo extraction (supports logo_url, logoUrl, logo) + http->https upgrade
  let logoUrl = team.logo_url || team.logoUrl || team.logo || "";
  if (logoUrl.startsWith("http://")) {
    logoUrl = logoUrl.replace("http://", "https://");
  }

  // Safe available shares extraction
  const availableShares = Number(
    team.availableShares ?? team.available_shares ?? 1000
  );

  // Safe spread price extraction with fallback to general price or 10.00
  const basePrice = Number(team.price ?? team.PRICE) || 10.0;
  const buyPrice = Number(team.buy_price ?? basePrice);
  const sellPrice = Number(team.sell_price ?? basePrice);

  return (
    <tr style={{ backgroundColor: "#ffffff" }}>
      {/* Team Column: Logo + Name */}
      <td style={tdStyle}>
        <div
          onClick={() => onSelect && onSelect(team)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
          }}
        >
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={team.name}
              referrerPolicy="no-referrer"
              style={{
                width: "28px",
                height: "28px",
                objectFit: "contain",
                flexShrink: 0,
              }}
              onError={(e) => {
                // Hide broken image icon if link fails
                e.target.style.display = "none";
              }}
            />
          ) : (
            <div
              style={{
                width: "28px",
                height: "28px",
                backgroundColor: "#e5e7eb",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "0.75rem",
                color: "#6b7280",
                fontWeight: "bold",
                flexShrink: 0,
              }}
            >
              {team.name ? team.name.charAt(0) : "?"}
            </div>
          )}

          <div>
            <div
              style={{
                fontWeight: "600",
                color: "#1d4ed8",
                textDecoration: "underline",
              }}
            >
              {team.name}
            </div>
            {sharesOwned > 0 && (
              <span
                style={{
                  fontSize: "0.75rem",
                  color: "#059669",
                  fontWeight: "bold",
                }}
              >
                Owned: {sharesOwned} sh
              </span>
            )}
          </div>
        </div>
      </td>

      {/* Buy Price Column */}
      <td style={{ ...tdStyle, fontWeight: "600", color: "#2563eb" }}>
        ${buyPrice.toFixed(2)}
      </td>

      {/* Sell Price Column */}
      <td style={{ ...tdStyle, fontWeight: "600", color: "#dc2626" }}>
        ${sellPrice.toFixed(2)}
      </td>

      {/* Available Shares Column */}
      <td style={tdStyle}>{availableShares}</td>

      {/* Quantity Input */}
      <td style={tdStyle}>
        <input
          type="number"
          min="1"
          max={availableShares}
          placeholder="0"
          value={quantity}
          onChange={(e) => onChange(teamId, e.target.value)}
          disabled={!marketOpen}
          style={{
            width: "60px",
            padding: "4px 8px",
            borderRadius: "4px",
            border: "1px solid #d1d5db",
          }}
        />
      </td>

      {/* Buy Button */}
      <td style={tdStyle}>
        <button
          onClick={() => onBuy(teamId, quantity)}
          disabled={!marketOpen || !quantity || quantity <= 0}
          style={{
            ...buttonStyle,
            backgroundColor:
              !marketOpen || !quantity || quantity <= 0 ? "#d1d5db" : "#2563eb",
            color: "white",
          }}
        >
          Buy
        </button>
      </td>

      {/* Sell Button */}
      <td style={tdStyle}>
        <button
          onClick={() => onSell(teamId, quantity)}
          disabled={
            !marketOpen || !quantity || quantity <= 0 || sharesOwned <= 0
          }
          style={{
            ...buttonStyle,
            backgroundColor:
              !marketOpen || !quantity || quantity <= 0 || sharesOwned <= 0
                ? "#d1d5db"
                : "#dc2626",
            color: "white",
          }}
        >
          Sell
        </button>
      </td>
    </tr>
  );
}

export default TeamRow;